import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Gif1 from "../../../../../assets/creative/Gif1.gif";
import Gif2 from "../../../../../assets/creative/Gif2.gif";
import Gif3 from "../../../../../assets/creative/Gif3.gif";

const Step2ChooseCreative = ({
  sectionTitleSx,
  sectionSubTextSx,
  primaryButtonSx,
  secondaryButtonSx,
  generatedAds,
  selectedAd,
  setSelectedAd,
  handleBack,
  handleNext,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewGif, setPreviewGif] = useState("");

  const handlePreview = (index) => {
    const gifMap = [Gif1, Gif2, Gif3];

    setPreviewGif(gifMap[index] || Gif1);
    setPreviewOpen(true);
  };

  return (
    <>
      <Typography variant="h5" sx={sectionTitleSx}>
        Choose Creative
      </Typography>

      <Typography sx={sectionSubTextSx}>
        Select one creative to generate your final tag
      </Typography>

      <Grid container spacing={4}>
        {generatedAds.map((ad, index) => {
          const adUrl = typeof ad === "string" ? ad : ad.url;

          return (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                onClick={() => setSelectedAd(index)}
                sx={{
                  borderRadius: "20px",
                  cursor: "pointer",
                  overflow: "hidden",
                  position: "relative",
                  border:
                    selectedAd === index
                      ? "3px solid #0049AA"
                      : "1px solid #e0e0e0",
                  boxShadow:
                    selectedAd === index
                      ? "0 12px 34px rgba(0,0,0,0.22)"
                      : "0 8px 22px rgba(0,0,0,0.10)",
                  transform: selectedAd === index ? "scale(1.04)" : "scale(1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                {/* MEDIA */}
                <Box sx={{ height: 320, background: "#f5f7fb" }}>
                  <video
                    src={adUrl}
                    muted
                    autoPlay
                    loop
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                      const img = e.target.nextSibling;
                      if (img) img.style.display = "block";
                    }}
                  />

                  <img
                    src={adUrl}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "none",
                    }}
                  />
                </Box>

                {/* PREVIEW BUTTON */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 70,
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  <Button
                    size="small"
                    variant="contained"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePreview(index);
                    }}
                    sx={{
                      borderRadius: "20px",
                      fontSize: "12px",
                      px: 2,
                      py: 0.5,
                    }}
                  >
                    Preview
                  </Button>
                </Box>

                {/* LABEL */}
                <Box
                  sx={{
                    p: 2,
                    textAlign: "center",
                    background: "#fafafa",
                    color: "#444",
                    fontWeight: 500,
                  }}
                >
                  {selectedAd === index
                    ? "✔ Selected Creative"
                    : "Click to Select"}
                </Box>

                {/* SELECTED BADGE */}
                {selectedAd === index && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 12,
                      right: 12,
                      background: "#0049AA",
                      color: "#fff",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "16px",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}
                  >
                    Selected
                  </Box>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* BUTTONS */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 5 }}>
        <Button variant="outlined" onClick={handleBack} sx={secondaryButtonSx}>
          Previous
        </Button>

        <Button
          variant="contained"
          onClick={handleNext}
          disabled={selectedAd === null}
          sx={primaryButtonSx}
        >
          Next
        </Button>
      </Box>

      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth={false}
        PaperProps={{
          sx: {
            background: "transparent",
            boxShadow: "none",
            overflow: "visible",
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.85)",
            backdropFilter: "blur(8px)",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={() => setPreviewOpen(false)}
            sx={{
              position: "absolute",
              top: -16,
              right: -16,
              bgcolor: "#fff",
              width: 42,
              height: 42,
              boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
              "&:hover": {
                bgcolor: "#f5f5f5",
                transform: "scale(1.08)",
              },
              transition: "all .25s ease",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* GIF */}
          <Box
            sx={{
              borderRadius: "24px",
              overflow: "hidden",
              boxShadow: "0 30px 80px rgba(0,0,0,.45)",
            }}
          >
            <img
              src={previewGif}
              alt="Creative Preview"
              style={{
                display: "block",
                height: "85vh",
                width: "auto",
                maxWidth: "95vw",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </Dialog>

      {/* GIF PREVIEW MODAL */}
      {/* <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={() => setPreviewOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 10,
              bgcolor: "#fff",
              "&:hover": {
                bgcolor: "#f5f5f5",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent sx={{ p: 0 }}>
            <img
              src={previewGif}
              alt="Creative Preview"
              style={{
                width: "100%",
                display: "block",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          </DialogContent>
        </Box>
      </Dialog> */}
    </>
  );
};

export default Step2ChooseCreative;
